<template>
  <div>
    <div>
      <div class="name-control"><span>宽：</span></div>
      <el-input-number
        size="mini"
        v-model="md"
        @change="handleChange('md')"
        :min="1"
        :max="12"
        label="描述文字"
      ></el-input-number>
    </div>
    <div>
      <div class="name-control"><span>高：</span></div>
      <el-input-number
        size="mini"
        v-model="height"
        @change="handleChange('height')"
        :min="1"
        :max="500"
        label="描述文字"
      ></el-input-number>
    </div>
    <div>
      <div class="name-control"><span>偏移量：</span></div>
      <el-input-number
        size="mini"
        v-model="offsetMd"
        @change="handleChange('offsetMd')"
        :min="0"
        :max="11"
        label="描述文字"
      ></el-input-number>
    </div>
    <div>
      <div class="name-control"><span>父高：</span></div>
      <el-input-number
        size="mini"
        v-model="parentHeight"
        @change="changeParent('height')"
        :min="0"
        :max="100"
        label="描述文字"
      ></el-input-number>
    </div>
    <div>
      <div class="name-control"><span>父宽：</span></div>
      <el-input-number
        size="mini"
        v-model="parentMd"
        @change="changeParent('md')"
        :min="0"
        :max="100"
        label="描述文字"
      ></el-input-number>
    </div>
    <div>
      <div class="name-control"><span>父偏移量：</span></div>
      <el-input-number
        size="mini"
        v-model="parentOffsetMd"
        @change="changeParent('offsetMd')"
        :min="0"
        :max="100"
        label="描述文字"
      ></el-input-number>
    </div>
  </div>
</template>

<script>
import { handleFindLayoutComponentOptionsColsParentRow, handleFindLayoutComponentOptionsCols } from "utils"
import { v1 } from "uuid"
const uuid = { v1 }
import { CATEGORY_MODE } from "@/consts"
export default {
  data() {
    return {
      parentHeight: null,
      parentMd: null,
      parentOffsetMd: null,
      height: 1,
      md: 12,
      offsetMd: 0
    }
  },
  methods: {
    handleChange(name) {
      const param = {
        ...this.ids,
        option_name: name,
        option_val: name === "height" ? this[name] + "%" : this[name]
      }
      this.$store.dispatch(this.request_prefix + "/changeColsSize", param)
    },
    changeParent(type) {
      const res1 = this.activeParentCol(this.ids.uid)
      const result = this.activeParentCol(res1.options.uid)
      const newVal = this["parent" + type.slice(0, 1).toUpperCase() + type.slice(1)]
      const param = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        uid: result.options.uid,
        option_name: type,
        option_val: type === "height" ? newVal + "%" : newVal
      }
      this.$store.dispatch(this.request_prefix + "/changeColsSize", param)
    },
    activeParentCol(uid) {
      const _uuid = uuid.v1()
      handleFindLayoutComponentOptionsColsParentRow(this.colOptions, uid, _uuid)
      const result = JSON.parse(window.localStorage.getItem(uid + _uuid))
      window.localStorage.removeItem(uid + _uuid)
      return result
    }
  },
  created() {
    this.md = this.activeCol.md
    this.height = parseInt(this.activeCol.height.slice(0, -1))
    this.offsetMd = this.activeCol.offsetMd
    const res1 = this.activeParentCol(this.ids.uid)
    const result = this.activeParentCol(res1.options.uid)
    this.parentHeight = parseInt(result.options.height.slice(0, -1))
    this.parentMd = parseInt(result.options.md)
    this.parentOffsetMd = parseInt(result.options.offsetMd)
    console.log(res1, result, result.options.height.slice(0, -1))
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    pOptions() {
      const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
      return [rectAttr.options.rows[useActiveIndex]]
    },
    colOptions() {
      return this.getRectAttribute.call(this, this.ids).options
    },
    activeCol() {
      return handleFindLayoutComponentOptionsCols(this.pOptions, this.ids.uid)
    }
  }
}
</script>

<style>
.name-control {
  display: inline-block;
  width: 4vw;
}
</style>
